import { render, staticRenderFns } from "./SubsectionHeader.vue?vue&type=template&id=ba1e4ede&scoped=true"
import script from "./SubsectionHeader.vue?vue&type=script&lang=js"
export * from "./SubsectionHeader.vue?vue&type=script&lang=js"
import style0 from "./SubsectionHeader.vue?vue&type=style&index=0&id=ba1e4ede&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba1e4ede",
  null
  
)

export default component.exports